// PeptideVault v6.5 — Charts + analytics

// ══════════════════════════════════════════════════════
// SVG CHART HELPERS
// ══════════════════════════════════════════════════════
function svgBarChart(data, opts = {}) {
  const W = opts.width || 560, H = opts.height || 200
  const padL = 40, padR = 10, padT = 10, padB = 30
  const chartW = W - padL - padR, chartH = H - padT - padB
  if (!data.length) return `<svg viewBox="0 0 ${W} ${H}" class="chart-svg"><text x="${W/2}" y="${H/2}" text-anchor="middle" class="axis-label">No data</text></svg>`

  const maxVal = Math.max(...data.map(d => d.values.reduce((a,v)=>a+v.value,0)), 1)
  const barW = chartW / data.length
  const barPad = Math.max(2, barW * 0.15)

  let bars = '', labels = '', yAxis = ''

  // Y axis ticks
  for (let i = 0; i <= 4; i++) {
    const y = padT + chartH - (i / 4) * chartH
    const val = Math.round(maxVal * i / 4)
    yAxis += `<line x1="${padL}" y1="${y.toFixed(1)}" x2="${padL+chartW}" y2="${y.toFixed(1)}" stroke="#e5e5e7" stroke-width="1"/>`
    yAxis += `<text x="${(padL-4).toFixed(1)}" y="${(y+3).toFixed(1)}" text-anchor="end" class="axis-label">${val}</text>`
  }

  data.forEach((d, i) => {
    const x = padL + i * barW + barPad
    const w = barW - barPad * 2
    const clickAttr = (opts.onClickMonth && d.monthKey) ? `onclick="${opts.onClickMonth}('${d.monthKey}')" style="cursor:pointer"` : ''
    let stackY = padT + chartH
    d.values.forEach(v => {
      const h = (v.value / maxVal) * chartH
      stackY -= h
      bars += `<rect class="chart-bar" x="${x.toFixed(1)}" y="${stackY.toFixed(1)}" width="${w.toFixed(1)}" height="${h.toFixed(1)}" fill="${v.color}" rx="2" title="${v.label}: ${v.value}" ${clickAttr}/>`
    })
    labels += `<text x="${(x + w/2).toFixed(1)}" y="${(padT+chartH+14).toFixed(1)}" text-anchor="middle" class="axis-label" ${clickAttr}>${d.label}</text>`
  })

  return `<svg viewBox="0 0 ${W} ${H}" class="chart-svg">${yAxis}${bars}${labels}</svg>`
}

function svgLineChart(series, opts = {}) {
  const W = opts.width || 560, H = opts.height || 180
  const padL = 44, padR = 10, padT = 10, padB = 30
  const chartW = W - padL - padR, chartH = H - padT - padB

  const allY = series.flatMap(s => s.points.map(p => p.y))
  const allX = series.flatMap(s => s.points.map(p => p.x))
  if (!allY.length) return `<svg viewBox="0 0 ${W} ${H}" class="chart-svg"><text x="${W/2}" y="${H/2}" text-anchor="middle" class="axis-label">No data</text></svg>`

  const minY = Math.min(...allY), maxY = Math.max(...allY)
  const minX = Math.min(...allX), maxX = Math.max(...allX)
  const rangeY = maxY - minY || 1, rangeX = maxX - minX || 1

  const px = x => padL + ((x - minX) / rangeX) * chartW
  const py = y => padT + chartH - ((y - minY) / rangeY) * chartH

  let grid = '', paths = '', dots = '', xLabels = '', yAxis = ''

  // Y axis
  for (let i = 0; i <= 4; i++) {
    const y = padT + chartH - (i/4)*chartH
    const val = (minY + (maxY-minY)*i/4).toFixed(1)
    grid += `<line x1="${padL}" y1="${y.toFixed(1)}" x2="${padL+chartW}" y2="${y.toFixed(1)}" stroke="#e5e5e7" stroke-width="1"/>`
    yAxis += `<text x="${(padL-4).toFixed(1)}" y="${(y+3).toFixed(1)}" text-anchor="end" class="axis-label">${val}</text>`
  }

  series.forEach(s => {
    if (!s.points.length) return
    const pts = s.points.map(p => `${px(p.x).toFixed(1)},${py(p.y).toFixed(1)}`).join(' ')
    paths += `<polyline points="${pts}" fill="none" stroke="${s.color}" stroke-width="2" stroke-linejoin="round"/>`
    // Dots on sparse data
    if (s.points.length < 30) {
      s.points.forEach(p => {
        dots += `<circle cx="${px(p.x).toFixed(1)}" cy="${py(p.y).toFixed(1)}" r="3" fill="${s.color}"/>`
      })
    }
  })

  // X axis labels (up to 6)
  const xPts = [...new Set(allX)].sort((a,b)=>a-b)
  const step = Math.max(1, Math.ceil(xPts.length / 6))
  xPts.filter((_,i) => i % step === 0).forEach(x => {
    xLabels += `<text x="${px(x).toFixed(1)}" y="${(padT+chartH+14).toFixed(1)}" text-anchor="middle" class="axis-label">${opts.xFmt ? opts.xFmt(x) : x}</text>`
  })

  return `<svg viewBox="0 0 ${W} ${H}" class="chart-svg">${grid}${yAxis}${paths}${dots}${xLabels}</svg>`
}

// ── Correlation chart ─────────────────────────────────
function renderCorrelationChart(injections, startDate, endDate) {
  const metric  = S.analyticsHealthMetric
  const pepId   = S.analyticsPeptide
  const today   = new Date(); today.setHours(23,59,59,999)

  // Health metric data in range
  const healthPts = S.healthData
    .filter(d => {
      if (d.type !== metric) return false
      const dt = new Date(d.date+'T12:00:00')
      if (dt > today) return false
      if (startDate && dt < startDate) return false
      if (dt > endDate) return false
      return true
    })
    .sort((a,b) => a.date.localeCompare(b.date))

  if (!healthPts.length) {
    return `<div style="color:var(--text4);font-size:13px;text-align:center;padding:24px">No ${HEALTH_TYPES[metric]?.label} data in this date range</div>`
  }

  // Injection activity per day (binary: did inject or not)
  const injDates = new Set(
    injections
      .filter(i => pepId === 'all' || i.peptideId === pepId || i.peptideName === S.peptides.find(p=>p.id===pepId)?.name)
      .map(i => i.date)
  )

  const W = 560, H = 220
  const padL = 44, padR = 44, padT = 16, padB = 30
  const cW = W - padL - padR, cH = H - padT - padB

  const minDate = new Date(healthPts[0].date+'T12:00:00').getTime()
  const maxDate = new Date(healthPts[healthPts.length-1].date+'T12:00:00').getTime()
  const dateRange = maxDate - minDate || 1

  const allY = healthPts.map(d => +d.value)
  const minY = Math.min(...allY), maxY = Math.max(...allY)
  const rangeY = maxY - minY || 1

  const px2 = ms  => padL + ((ms - minDate) / dateRange) * cW
  const py2 = val => padT + cH - ((val - minY) / rangeY) * cH

  // Health line
  let healthPath = '', healthDots = ''
  const pts = healthPts.map(d => {
    const x = px2(new Date(d.date+'T12:00:00').getTime())
    const y = py2(+d.value)
    return `${x.toFixed(1)},${y.toFixed(1)}`
  })
  healthPath = `<polyline points="${pts.join(' ')}" fill="none" stroke="var(--blue)" stroke-width="2" stroke-linejoin="round"/>`
  if (healthPts.length < 60) {
    healthDots = healthPts.map(d => {
      const x = px2(new Date(d.date+'T12:00:00').getTime()), y = py2(+d.value)
      return `<circle cx="${x.toFixed(1)}" cy="${y.toFixed(1)}" r="3" fill="var(--blue)"/>`
    }).join('')
  }

  // Injection day shading — find contiguous injection runs
  let injBands = ''
  const sortedDates = [...injDates].sort()
  if (sortedDates.length) {
    let runStart = sortedDates[0]
    let prev     = sortedDates[0]
    for (let i = 1; i <= sortedDates.length; i++) {
      const curr = sortedDates[i]
      const gap  = curr ? (new Date(curr).getTime() - new Date(prev).getTime()) / 86400000 : 999
      if (gap > 2 || !curr) {
        const x1 = Math.max(padL, px2(new Date(runStart+'T00:00:00').getTime()))
        const x2 = Math.min(padL+cW, px2(new Date(prev+'T23:59:59').getTime()) + 4)
        if (x2 > x1)
          injBands += `<rect x="${x1.toFixed(1)}" y="${padT}" width="${(x2-x1).toFixed(1)}" height="${cH}" fill="var(--greenL)" opacity="0.6"/>`
        runStart = curr
      }
      prev = curr
    }
  }

  // Y axis
  let yAxis = ''
  for (let i = 0; i <= 4; i++) {
    const y   = padT + cH - (i/4)*cH
    const val = (minY + rangeY*i/4).toFixed(1)
    yAxis += `<line x1="${padL}" y1="${y.toFixed(1)}" x2="${padL+cW}" y2="${y.toFixed(1)}" stroke="#e5e5e7" stroke-width="1"/>`
    yAxis += `<text x="${(padL-4).toFixed(1)}" y="${(y+3).toFixed(1)}" text-anchor="end" class="axis-label">${val}</text>`
  }

  // X axis labels
  let xLabels = ''
  const step = Math.max(1, Math.floor(healthPts.length/5))
  healthPts.filter((_,i)=>i%step===0).forEach(d => {
    const x = px2(new Date(d.date+'T12:00:00').getTime())
    xLabels += `<text x="${x.toFixed(1)}" y="${(padT+cH+14).toFixed(1)}" text-anchor="middle" class="axis-label">${new Date(d.date+'T12:00:00').toLocaleDateString('en-US',{month:'short',day:'numeric'})}</text>`
  })

  // Right Y axis label
  const unitLabel = HEALTH_TYPES[metric]?.unit || ''
  const pepLabel  = pepId === 'all' ? 'All Peptides' : (S.peptides.find(p=>p.id===pepId)?.name||'')

  return `
    <svg viewBox="0 0 ${W} ${H}" class="chart-svg">
      ${injBands}${yAxis}${healthPath}${healthDots}${xLabels}
      <text x="${padL}" y="${padT-2}" class="axis-label" fill="var(--blue)" font-weight="700">${HEALTH_TYPES[metric]?.label} (${unitLabel})</text>
    </svg>
    <div style="display:flex;gap:16px;font-size:12px;color:var(--text3);margin-top:6px">
      <span><span style="display:inline-block;width:12px;height:8px;background:var(--greenL);border-radius:2px;opacity:.8"></span> Injection days (${esc(pepLabel)})</span>
      <span><span style="display:inline-block;width:24px;height:2px;background:var(--blue);vertical-align:middle"></span> ${HEALTH_TYPES[metric]?.label}</span>
    </div>`
}

// ══════════════════════════════════════════════════════
// RENDER: ANALYTICS TAB
// ══════════════════════════════════════════════════════
function renderAnalyticsTab() {
  const today = new Date(); today.setHours(23,59,59,999)

  // Date range — custom start/end or preset shortcuts
  const endDate   = S.analyticsEnd   ? new Date(S.analyticsEnd   + 'T23:59:59') : today
  const startDate = S.analyticsStart ? new Date(S.analyticsStart + 'T00:00:00') : null

  const filtered = S.injections.filter(inj => {
    const d = new Date(inj.date + 'T12:00:00')
    if (d > today) return false
    if (startDate && d < startDate) return false
    if (d > endDate) return false
    return true
  })

  // Stats
  const totalInj  = filtered.length
  const uniquePeps = new Set(filtered.map(i => i.peptideName)).size
  const thisMonth  = filtered.filter(i => {
    const d = new Date(i.date + 'T12:00:00')
    return d.getMonth() === today.getMonth() && d.getFullYear() === today.getFullYear()
  }).length

  // Injections per month
  const monthMap = {}
  filtered.forEach(inj => {
    const d = new Date(inj.date + 'T12:00:00')
    const key   = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`
    const label = d.toLocaleDateString('en-US', {month:'short', year:'2-digit'})
    if (!monthMap[key]) monthMap[key] = { label, peptides:{}, injections:[] }
    monthMap[key].peptides[inj.peptideName] = (monthMap[key].peptides[inj.peptideName]||0) + 1
    monthMap[key].injections.push(inj)
  })
  const months     = Object.entries(monthMap).sort((a,b) => a[0].localeCompare(b[0]))
  const allPepNames = [...new Set(filtered.map(i => i.peptideName))]

  const barData = months.map(([key,v]) => ({
    label: v.label,
    monthKey: key,
    values: allPepNames.map(pn => ({ label:pn, value:v.peptides[pn]||0, color:peptideColor(pn) })).filter(x=>x.value>0)
  }))

  // Cost tracking — injection records × (cost/vial ÷ doses/vial)
  // Build cost-per-injection lookup by peptide name (use cheapest SKU with both fields)
  const costPerInj = {}  // peptideName → $/injection
  for (const p of S.peptides) {
    for (const s of (p.skus||[])) {
      const cost  = +(s.costPerVial  || 0)
      const doses = +(s.dosesPerVial || 0)
      if (!cost || !doses) continue
      const perInj = cost / doses
      // Use lowest cost/injection across SKUs (most conservative estimate)
      if (!costPerInj[p.name] || perInj < costPerInj[p.name]) {
        costPerInj[p.name] = perInj
      }
    }
  }

  const costByMonth = {}
  filtered.forEach(inj => {
    const perInj = costPerInj[inj.peptideName]
    if (!perInj) return
    const d = new Date(inj.date + 'T12:00:00')
    const mKey = `${d.getFullYear()}-${String(d.getMonth()+1).padStart(2,'0')}`
    costByMonth[mKey] = (costByMonth[mKey]||0) + perInj
  })

  const totalCost   = Object.values(costByMonth).reduce((a,b) => a+b, 0)
  const hasCostData = totalCost > 0
  const hasCostConfig = Object.keys(costPerInj).length > 0

  const pepFreq = {}
  filtered.forEach(i => pepFreq[i.peptideName] = (pepFreq[i.peptideName]||0)+1)
  const sortedPeps = Object.entries(pepFreq).sort((a,b) => b[1]-a[1])

  const invData = S.peptides.map(p => ({ name:p.name, qty:peptideQty(p), color:peptideColor(p.name) })).filter(p=>p.qty>0).sort((a,b)=>b.qty-a.qty)

  // Preset shortcuts
  const presets = [
    ['30','30d'],['90','90d'],['180','6m'],['365','1yr'],['','All'],
  ]
  function presetDates(days) {
    if (!days) return { start:'', end:'' }
    const s = new Date(Date.now() - +days*86400000)
    return { start: localDateStr(s), end: '' }
  }
  function isPresetActive(days) {
    if (!days) return !S.analyticsStart && !S.analyticsEnd
    const expected = presetDates(days)
    return S.analyticsStart === expected.start && !S.analyticsEnd
  }

  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:16px">
      <h2 style="font-size:20px;font-weight:700">Analytics</h2>
    </div>

    <!-- Date range pickers -->
    <div class="card" style="margin-bottom:16px;padding:0">
      <div class="card-body" style="display:flex;flex-direction:column;gap:12px">
        <div class="row" style="gap:12px;flex-wrap:wrap;align-items:flex-end">
          <div class="form-group" style="margin:0;flex:1;min-width:140px">
            <label class="form-label">Start Date</label>
            <input class="form-input" type="date" value="${S.analyticsStart}"
              oninput="S.analyticsStart=this.value;render()">
          </div>
          <div class="form-group" style="margin:0;flex:1;min-width:140px">
            <label class="form-label">End Date</label>
            <input class="form-input" type="date" value="${S.analyticsEnd}"
              oninput="S.analyticsEnd=this.value;render()">
          </div>
          <button class="btn btn-ghost btn-sm" onclick="S.analyticsStart='';S.analyticsEnd='';render()" style="flex-shrink:0">Clear</button>
        </div>
        <div class="filter-bar" style="margin:0">
          <span style="font-size:11px;font-weight:700;color:var(--text4)">Quick:</span>
          ${presets.map(([d,l]) => {
            const p = presetDates(d)
            const active = isPresetActive(d)
            return `<button class="filter-btn ${active?'active':''}" onclick="S.analyticsStart='${p.start}';S.analyticsEnd='${p.end}';render()">${l}</button>`
          }).join('')}
        </div>
      </div>
    </div>

    <!-- Summary stats -->
    <div class="stat-grid">
      <div class="stat-card"><div class="stat-value">${totalInj}</div><div class="stat-label">Total Injections</div></div>
      <div class="stat-card"><div class="stat-value">${uniquePeps}</div><div class="stat-label">Active Peptides</div></div>
      <div class="stat-card"><div class="stat-value">${thisMonth}</div><div class="stat-label">This Month</div></div>
      ${hasCostData
        ? `<div class="stat-card"><div class="stat-value" style="font-size:18px">$${totalCost.toFixed(0)}</div><div class="stat-label">Est. Total Cost</div></div>`
        : hasCostConfig
          ? `<div class="stat-card"><div class="stat-value" style="font-size:14px;color:var(--text3)">No data</div><div class="stat-label">Cost (no injections matched)</div></div>`
          : `<div class="stat-card"><div class="stat-value">${S.peptides.length}</div><div class="stat-label">Peptides Tracked</div></div>`}
    </div>

    <!-- Injections per month (clickable) -->
    ${barData.length ? `
    <div class="chart-wrap">
      <div class="chart-title">Injections per Month <span style="font-size:11px;font-weight:400;color:var(--text4)">(click a bar to see details)</span></div>
      ${svgBarChart(barData, { height: 200, onClickMonth: 'showMonthDetail' })}
      <div class="chart-legend">
        ${allPepNames.map(n=>`<div class="chart-legend-item"><div class="chart-legend-dot" style="background:${peptideColor(n)}"></div>${esc(n)}</div>`).join('')}
      </div>
    </div>` : ''}

    <!-- Monthly cost chart -->
    ${hasCostData ? `
    <div class="chart-wrap">
      <div class="chart-title">Estimated Monthly Cost ($) <span style="font-weight:400;font-size:11px;color:var(--text4)">based on cost/vial ÷ doses/vial × injections</span></div>
      ${svgBarChart(
        Object.entries(costByMonth).sort((a,b)=>a[0].localeCompare(b[0])).map(([key,cost]) => {
          const [yr,mo] = key.split('-')
          const yr2 = parseInt(yr,10), mo2 = parseInt(mo,10)
          const label = (!isNaN(yr2) && !isNaN(mo2))
            ? new Date(yr2, mo2-1, 15).toLocaleDateString('en-US',{month:'short',year:'2-digit'})
            : key
          return { label, values:[{ label:'Cost', value:+cost.toFixed(2), color:'#009E73' }] }
        }),
        { height:160 }
      )}
    </div>` : S.peptides.some(p=>p.skus?.some(s=>s.costPerVial&&!s.dosesPerVial)) ? `
    <div style="background:var(--yellowL);border:1px solid var(--border);border-radius:var(--r);padding:12px 16px;font-size:13px;color:var(--yellowT);margin-bottom:16px">
      💡 To enable cost tracking: edit your SKUs and add <strong>Doses Per Vial</strong> alongside the existing Cost Per Vial.
    </div>` : ''}

    <!-- Correlation: health metric vs injection activity -->
    ${S.healthData.length ? `
    <div class="chart-wrap">
      <div class="chart-title">Correlation — Health Metric vs Injections</div>
      <div class="row" style="gap:10px;margin-bottom:12px;flex-wrap:wrap">
        <div class="form-group" style="margin:0;min-width:160px">
          <label class="form-label">Health Metric</label>
          <select class="form-input form-select" onchange="S.analyticsHealthMetric=this.value;render()">
            ${Object.entries(HEALTH_TYPES).map(([k,v])=>`<option value="${k}" ${S.analyticsHealthMetric===k?'selected':''}>${v.label}</option>`).join('')}
          </select>
        </div>
        <div class="form-group" style="margin:0;min-width:160px">
          <label class="form-label">Peptide / All</label>
          <select class="form-input form-select" onchange="S.analyticsPeptide=this.value;render()">
            <option value="all" ${S.analyticsPeptide==='all'?'selected':''}>All Peptides</option>
            ${S.peptides.map(p=>`<option value="${p.id}" ${S.analyticsPeptide===p.id?'selected':''}>${esc(p.name)}</option>`).join('')}
          </select>
        </div>
      </div>
      ${renderCorrelationChart(filtered, startDate, endDate)}
    </div>` : ''}

    <!-- Peptide frequency horizontal bars -->
    ${sortedPeps.length ? `
    <div class="chart-wrap">
      <div class="chart-title">Injections by Peptide</div>
      <div style="display:flex;flex-direction:column;gap:8px">
        ${sortedPeps.map(([name, count]) => {
          const pct = (count / sortedPeps[0][1]) * 100
          return `<div>
            <div class="row" style="margin-bottom:4px">
              <span style="font-size:13px;font-weight:500;flex:1">${esc(name)}</span>
              <span style="font-size:13px;font-weight:700;color:${peptideColor(name)}">${count}</span>
            </div>
            <div style="height:8px;background:var(--bg4);border-radius:4px;overflow:hidden">
              <div style="height:100%;width:${pct.toFixed(1)}%;background:${peptideColor(name)};border-radius:4px;transition:width .4s ease"></div>
            </div>
          </div>`
        }).join('')}
      </div>
    </div>` : ''}

    <!-- Current inventory -->
    ${invData.length ? `
    <div class="chart-wrap">
      <div class="chart-title">Current Inventory (Vials)</div>
      <div style="display:flex;flex-direction:column;gap:8px">
        ${invData.map(p => {
          const maxQ = invData[0].qty
          return `<div>
            <div class="row" style="margin-bottom:4px">
              <span style="font-size:13px;font-weight:500;flex:1">${esc(p.name)}</span>
              <span style="font-size:13px;font-weight:700;color:${p.color}">${p.qty} vials</span>
            </div>
            <div style="height:8px;background:var(--bg4);border-radius:4px;overflow:hidden">
              <div style="height:100%;width:${((p.qty/maxQ)*100).toFixed(1)}%;background:${p.color};border-radius:4px"></div>
            </div>
          </div>`
        }).join('')}
      </div>
    </div>` : ''}

    ${!totalInj ? `
    <div class="card">
      <div class="empty-state" style="padding:48px">
        <div class="empty-icon">📊</div>
        <p>No injection data yet</p>
        <span>Import a CSV from the Calendar tab to see analytics</span>
      </div>
    </div>` : ''}
  </div>`
}

// ── Cumulative PK model (superposition) ──────────────
// Given a set of injection times (in hours relative to window start),
// returns the cumulative % of single-dose peak at time t_hours.
// Can exceed 100% when doses accumulate (trough buildup).
function cumulativeLevel(t_hours, injTimes_hours, halfLife, ka) {
  let total = 0
  for (const ti of injTimes_hours) {
    const elapsed = t_hours - ti
    if (elapsed < 0) continue
    total += batemanPct(elapsed, halfLife, ka)
  }
  return total
}

// Convert injection calendar entries for a peptide to hours from windowStart
function injectionTimesForPK(peptideId, peptideName, windowStart_date, windowEnd_date) {
  const times = []
  for (const inj of S.injections) {
    if (inj.peptideId !== peptideId && inj.peptideName !== peptideName) continue
    const injDate = new Date(inj.date + 'T12:00:00')
    // Use stored time if available, else noon
    if (inj.time) {
      const t24 = timeStrTo24(inj.time)
      injDate.setHours(+t24.slice(0,2), +t24.slice(2,4), 0, 0)
    }
    if (injDate > windowEnd_date) continue
    const hoursFromStart = (injDate - windowStart_date) / 3600000
    times.push(hoursFromStart)
  }
  return times.sort((a,b) => a-b)
}



// Bateman equation — SubQ first-order absorption + elimination
// Returns relative % of peak concentration at time t (hours)
function batemanPct(t, halfLife, ka) {
  if (t < 0 || !halfLife || halfLife <= 0) return 0
  const ke = Math.LN2 / halfLife
  if (Math.abs(ka - ke) < 0.001) {
    // Special case: ka ≈ ke (L'Hôpital limit)
    const C = ka * t * Math.exp(-ke * t)
    // Normalize: max of ka*t*e^(-ke*t) occurs at t=1/ke
    const Cmax = (1/ke) * Math.exp(-1)
    return Math.max(0, Math.min(100, (C / Cmax) * 100))
  }
  const C = (ka / (ka - ke)) * (Math.exp(-ke * t) - Math.exp(-ka * t))
  // Find Cmax numerically (tmax = ln(ka/ke)/(ka-ke))
  const tmax = Math.log(ka / ke) / (ka - ke)
  const Cmax = (ka / (ka - ke)) * (Math.exp(-ke * tmax) - Math.exp(-ka * tmax))
  return Math.max(0, Math.min(100, (C / Cmax) * 100))
}

function renderHalfLifeTab() {
  // Include blends if any component peptide has a half-life
  const pepWithHL = S.peptides.filter(p => {
    if (p.halfLife && +p.halfLife > 0) return true
    if (p.isBlend && p.blendComponents?.length) {
      return p.blendComponents.some(c => {
        // Component has its own half-life set directly
        if (c.halfLife && +c.halfLife > 0) return true
        // Or linked to a peptide with a half-life
        const comp = getPeptide(c.peptideId) || S.peptides.find(x => x.name === c.peptideName)
        return comp?.halfLife && +comp.halfLife > 0
      })
    }
    return false
  })
  const selected  = S.hlSelected.filter(id => pepWithHL.find(p => p.id === id))

  // Last injection per peptide
  const lastInj = {}
  for (const inj of S.injections) {
    const p = S.peptides.find(x => x.id === inj.peptideId || x.name === inj.peptideName)
    if (!p || !p.halfLife) continue
    const existing = lastInj[p.id]
    if (!existing || inj.date > existing.date || (inj.date === existing.date && inj.time > existing.time)) {
      lastInj[p.id] = inj
    }
  }

  // Build SVG curve
  let curveSVG = ''
  const W = 560, H = 280
  const padL = 44, padR = 20, padT = 20, padB = 35
  const cW = W - padL - padR, cH = H - padT - padB

  // Build list of peptides to plot — expand blends into components
  const pepsToPLot = []
  for (const id of selected) {
    const pep = pepWithHL.find(p => p.id === id)
    if (!pep) continue
    if (pep.isBlend && pep.blendComponents?.length) {
      // Expand blend: each component gets its own curve
      for (const c of pep.blendComponents) {
        // Use component-level half-life if set, otherwise look up linked peptide
        const compHL = c.halfLife && +c.halfLife > 0 ? +c.halfLife : null
        const compKA = c.absorptionRate && +c.absorptionRate > 0 ? +c.absorptionRate : null
        const compPep = getPeptide(c.peptideId) || S.peptides.find(p => p.name === c.peptideName)

        const hl = compHL || (compPep?.halfLife && +compPep.halfLife > 0 ? +compPep.halfLife : null)
        const ka = compKA || (compPep?.absorptionRate ? +compPep.absorptionRate : 0.8)

        if (!hl) continue  // skip if no half-life available

        // Create a virtual peptide object for the curve
        const virtual = {
          id: c.peptideId || ('virtual_' + c.peptideName),
          name: c.peptideName,
          halfLife: hl,
          absorptionRate: ka
        }
        pepsToPLot.push({ pep: virtual, blendName: pep.name, injKey: id })
      }
    } else {
      pepsToPLot.push({ pep, blendName: null, injKey: id })
    }
  }

  if (pepsToPLot.length) {
    const maxHL = Math.max(...pepsToPLot.map(x=>+(x.pep?.halfLife||4)))
    const maxT  = Math.min(maxHL * 6, 240)
    const threshold = +S.hlThreshold || 20
    const steps = 200

    // Grid
    let grid = '', xLabels = '', yLabels = ''
    for (let i = 0; i <= 5; i++) {
      const y = padT + cH - (i/5)*cH
      const pct = i * 20
      grid += `<line x1="${padL}" y1="${y.toFixed(1)}" x2="${padL+cW}" y2="${y.toFixed(1)}" stroke="${i===0?'#636366':'#e5e5e7'}" stroke-width="${i===0?1.5:1}"/>`
      yLabels += `<text x="${(padL-5).toFixed(1)}" y="${(y+3).toFixed(1)}" text-anchor="end" class="axis-label">${pct}%</text>`
    }
    for (let i = 0; i <= 6; i++) {
      const x = padL + (i/6)*cW
      const hr = Math.round(maxT * i/6)
      grid += `<line x1="${x.toFixed(1)}" y1="${padT}" x2="${x.toFixed(1)}" y2="${(padT+cH).toFixed(1)}" stroke="#e5e5e7" stroke-width="1"/>`
      xLabels += `<text x="${x.toFixed(1)}" y="${(padT+cH+14).toFixed(1)}" text-anchor="middle" class="axis-label">${hr}h</text>`
    }

    // Threshold line
    const tyPct = threshold / 100
    const ty = padT + cH - tyPct * cH
    grid += `<line x1="${padL}" y1="${ty.toFixed(1)}" x2="${(padL+cW).toFixed(1)}" y2="${ty.toFixed(1)}" stroke="var(--yellow)" stroke-width="1.5" stroke-dasharray="6,3"/>`
    grid += `<text x="${(padL+cW+2).toFixed(1)}" y="${(ty+3).toFixed(1)}" class="axis-label" fill="var(--yellowT)">${threshold}%</text>`

    let curves = '', nowLines = '', peaks = ''

    pepsToPLot.forEach(({ pep, blendName, injKey }) => {
      const hl = +pep.halfLife
      const ka = +(pep.absorptionRate || 0.8)
      const color = peptideColor(pep.name)
      const displayName = blendName ? `${pep.name} (via ${blendName})` : pep.name

      // Determine t=0 from last injection of the parent (blend or individual)
      const injRef = lastInj[injKey] || lastInj[pep.id]
      let injOffset = 0
      if (S.hlFromLast && injRef) {
        const injDt = new Date(`${injRef.date}T${timeStrTo24(injRef.time).replace(/(\d{2})(\d{2})(\d{2})/,'$1:$2:$3')}`)
        injOffset = (Date.now() - injDt.getTime()) / 3600000
      } else if (!S.hlFromLast && S.hlCustomDate && S.hlCustomTime) {
        const injDt = new Date(`${S.hlCustomDate}T${S.hlCustomTime}:00`)
        injOffset = (Date.now() - injDt.getTime()) / 3600000
      }

      // Build path
      let pathPts = []
      for (let i = 0; i <= steps; i++) {
        const t = (i / steps) * maxT
        const pct = batemanPct(t, hl, ka)
        const x = padL + (t / maxT) * cW
        const y = padT + cH - (pct / 100) * cH
        pathPts.push(`${x.toFixed(1)},${y.toFixed(1)}`)
      }
      curves += `<polyline points="${pathPts.join(' ')}" fill="none" stroke="${color}" stroke-width="2.5" stroke-linejoin="round" opacity="0.9"/>`

      // "Now" dot
      if (injOffset > 0 && injOffset < maxT) {
        const nx = padL + (injOffset / maxT) * cW
        const nowPct = batemanPct(injOffset, hl, ka)
        const ny = padT + cH - (nowPct/100)*cH
        nowLines += `<line x1="${nx.toFixed(1)}" y1="${padT}" x2="${nx.toFixed(1)}" y2="${(padT+cH).toFixed(1)}" stroke="${color}" stroke-width="1" stroke-dasharray="4,3" opacity="0.6"/>`
        nowLines += `<circle cx="${nx.toFixed(1)}" cy="${ny.toFixed(1)}" r="5" fill="${color}"/>`
        nowLines += `<text x="${(nx+6).toFixed(1)}" y="${(ny-6).toFixed(1)}" class="axis-label" fill="${color}" font-weight="700">${nowPct.toFixed(0)}%</text>`
      }

      // Peak marker
      const tmax = Math.log(ka / (Math.LN2/hl)) / (ka - Math.LN2/hl)
      if (tmax > 0 && tmax < maxT) {
        const px2 = padL + (tmax/maxT)*cW
        const py2 = padT + cH - cH // peak = 100%
        peaks += `<circle cx="${px2.toFixed(1)}" cy="${py2.toFixed(1)}" r="4" fill="${color}" stroke="white" stroke-width="1.5"/>`
        peaks += `<text x="${px2.toFixed(1)}" y="${(py2-8).toFixed(1)}" text-anchor="middle" class="axis-label" fill="${color}" font-weight="700">Peak ${tmax.toFixed(1)}h</text>`
      }
    })

    curveSVG = `<svg viewBox="0 0 ${W} ${H}" class="chart-svg" style="max-width:100%">${grid}${xLabels}${yLabels}${curves}${nowLines}${peaks}</svg>`
  } // end if pepsToPLot.length

  return `
  <div style="animation:fadeIn .25s ease">
    <div class="row" style="margin-bottom:16px">
      <h2 style="font-size:20px;font-weight:700">Half-Life Viewer</h2>
    </div>

    ${pepWithHL.length === 0 ? `
    <div class="card">
      <div class="empty-state" style="padding:48px">
        <div class="empty-icon">📉</div>
        <p>No half-life data configured</p>
        <span>Edit any peptide and enter its Half-Life (hours) to use this viewer</span>
      </div>
    </div>` : `

    <!-- Controls -->
    <div class="hl-controls">
      <div style="font-size:12px;font-weight:700;color:var(--text3);text-transform:uppercase;letter-spacing:.5px;margin-bottom:10px">Select Peptides</div>
      <!-- Mode toggle -->
      <div class="row" style="gap:8px;margin-bottom:12px">
        <button class="btn btn-sm ${S.hlMode==='single'?'btn-primary':'btn-secondary'}" onclick="S.hlMode='single';render()">Single Dose Preview</button>
        <button class="btn btn-sm ${S.hlMode==='calendar'?'btn-primary':'btn-secondary'}" onclick="S.hlMode='calendar';render()">📅 From Calendar (Actual Levels)</button>
      </div>

      <div class="hl-peptide-grid">
        ${pepWithHL.map(p => `
        <div class="hl-peptide-check ${selected.includes(p.id)?'selected':''}" onclick="hlToggle('${p.id}')">
          <div style="width:10px;height:10px;border-radius:50%;background:${peptideColor(p.name)};flex-shrink:0"></div>
          <div style="flex:1;min-width:0">
            <div style="font-size:13px;font-weight:600;overflow:hidden;text-overflow:ellipsis;white-space:nowrap">${esc(p.name)}</div>
            <div style="font-size:11px;color:var(--text3)">
              ${p.isBlend && p.blendComponents?.length
                ? `Blend: ${p.blendComponents.map(c=>c.peptideName).join(', ')}`
                : `t½ = ${p.halfLife}h · ka = ${p.absorptionRate||0.8}/h`}
            </div>
          </div>
        </div>`).join('')}
      </div>

      ${S.hlMode === 'single' ? `
      <div class="form-row form-row-3">
        <div class="form-group">
          <label class="form-label">Reference Point</label>
          <select class="form-input form-select" onchange="S.hlFromLast=this.value==='last';render()">
            <option value="last" ${S.hlFromLast?'selected':''}>From last injection</option>
            <option value="custom" ${!S.hlFromLast?'selected':''}>Custom date/time</option>
          </select>
        </div>
        ${!S.hlFromLast ? `
        <div class="form-group">
          <label class="form-label">Injection Date</label>
          <input class="form-input" type="date" value="${S.hlCustomDate}" oninput="S.hlCustomDate=this.value;render()">
        </div>
        <div class="form-group">
          <label class="form-label">Injection Time</label>
          <input class="form-input" type="time" value="${S.hlCustomTime}" oninput="S.hlCustomTime=this.value;render()">
        </div>` : `<div></div><div></div>`}
      </div>` : `
      <div class="form-row form-row-3">
        <div class="form-group">
          <label class="form-label">Time Window</label>
          <select class="form-input form-select" onchange="S.hlWindowDays=+this.value;render()">
            ${[7,14,30,60,90].map(d=>`<option value="${d}" ${S.hlWindowDays===d?'selected':''}>${d} days</option>`).join('')}
          </select>
        </div>
        <div class="form-group" style="grid-column:span 2">
          <label class="form-label" style="opacity:0">.</label>
          <div style="font-size:12px;color:var(--text3);padding-top:8px">Shows cumulative levels from all injections in the window. Multiple doses build up — levels can exceed 100% of single-dose peak.</div>
        </div>
      </div>`}

      <div class="form-group" style="margin-top:8px">
        <label class="form-label">Threshold line: <strong>${S.hlThreshold}%</strong></label>
        <input type="range" min="5" max="50" step="5" value="${S.hlThreshold}"
          style="width:200px;accent-color:var(--yellow)"
          oninput="S.hlThreshold=+this.value;document.getElementById('hl-thresh-label').textContent=this.value+'%'">
        <span id="hl-thresh-label" style="font-size:12px;color:var(--text3);margin-left:8px">${S.hlThreshold}%</span>
      </div>
    </div>

    <!-- Curve -->
    ${selected.length ? `
    <div class="chart-wrap">
      <div class="chart-title">${S.hlMode === 'calendar'
        ? 'Actual Cumulative Levels (% of Single-Dose Peak) — from injection calendar'
        : 'Relative Concentration (% of Peak) — SubQ single dose preview'}</div>
      ${S.hlMode === 'calendar' ? renderCalendarPKChart(pepsToPLot) : curveSVG}
      <div class="chart-legend" style="margin-top:12px">
        ${renderHLLegend(pepsToPLot, lastInj)}
      </div>
      <div style="font-size:12px;color:var(--text4);margin-top:8px">
        ${S.hlMode === 'calendar'
          ? '● = now &nbsp; — — = threshold &nbsp; Levels >100% = dose accumulation above single-dose peak'
          : '● = current level &nbsp; ◌ = peak &nbsp; — — = threshold &nbsp; Bateman SubQ model'}
      </div>
    </div>

    <!-- Washout clearance summary (single dose mode only) -->
    ${S.hlMode === 'single' && pepsToPLot.length ? `
    <div class="chart-wrap" style="margin-top:0">
      <div class="chart-title">Clearance Times (below ${S.hlThreshold}% threshold)</div>
      <table style="width:100%;border-collapse:collapse;font-size:13px">
        <thead>
          <tr style="border-bottom:1px solid var(--border)">
            <th style="padding:8px 0;text-align:left;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Peptide</th>
            <th style="padding:8px 0;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Last Injection</th>
            <th style="padding:8px 0;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Current Level</th>
            <th style="padding:8px 0;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Clears At</th>
            <th style="padding:8px 0;text-align:right;font-size:11px;font-weight:700;color:var(--text4);text-transform:uppercase">Hours Left</th>
          </tr>
        </thead>
        <tbody>
          ${pepsToPLot.map(({ pep, blendName, injKey }) => {
            const hl    = +pep.halfLife
            const ka    = +(pep.absorptionRate||0.8)
            const inj   = lastInj[injKey] || lastInj[pep.id]
            if (!inj) return `<tr><td colspan="5" style="padding:8px 0;color:var(--text4)">${esc(pep.name)}${blendName?` (${esc(blendName)})`:''} — no injection data</td></tr>`
            const injDt = new Date(inj.date + 'T12:00:00')
            const elapsed = (Date.now() - injDt.getTime()) / 3600000
            const currentPct = batemanPct(elapsed, hl, ka)
            const clearHours = washoutTime(hl, ka, +S.hlThreshold)
            const hoursLeft  = clearHours - elapsed
            const clearDate  = new Date(injDt.getTime() + clearHours*3600000)
            const alreadyClear = currentPct <= +S.hlThreshold
            return `<tr style="border-bottom:1px solid var(--border2)">
              <td style="padding:8px 0;font-weight:600;color:${peptideColor(pep.name)}">${esc(pep.name)}${blendName?`<span style="color:var(--text4);font-weight:400"> (${esc(blendName)})</span>`:''}</td>
              <td style="padding:8px 0;text-align:right;color:var(--text3)">${fmt(inj.date)} ${inj.time?fmt12(inj.time):''}</td>
              <td style="padding:8px 0;text-align:right;font-weight:700;color:${currentPct>S.hlThreshold?'var(--blue)':'var(--green)'}">${currentPct.toFixed(1)}%</td>
              <td style="padding:8px 0;text-align:right">${alreadyClear ? '<span style="color:var(--green)">Already clear</span>' : fmt(localDateStr(clearDate))}</td>
              <td style="padding:8px 0;text-align:right;font-weight:700;color:${alreadyClear?'var(--green)':'var(--text)'}">${alreadyClear ? '✓' : Math.ceil(hoursLeft)+'h'}</td>
            </tr>`
          }).join('')}
        </tbody>
      </table>
    </div>` : ''}` : `
    <div style="color:var(--text4);font-size:13px;text-align:center;padding:32px">Select one or more peptides above to view their concentration curves</div>`}
  </div>`}
  </div>`
}

function renderCalendarPKChart(pepsToPLot) {
  const W = 560, H = 300
  const padL = 48, padR = 20, padT = 20, padB = 40
  const cW = W - padL - padR, cH = H - padT - padB

  const windowMs  = S.hlWindowDays * 86400000
  const now       = new Date()
  const winStart  = new Date(now.getTime() - windowMs)
  const maxHL     = Math.max(...pepsToPLot.map(x => +(x.pep?.halfLife||4)), 4)
  const futureMs  = Math.min(maxHL * 3, 72) * 3600000
  const winEnd    = new Date(now.getTime() + futureMs)
  const totalMs   = winEnd - winStart
  const totalHrs  = totalMs / 3600000

  const curves = []
  let globalMax = 0

  for (const { pep, blendName, injKey } of pepsToPLot) {
    const hl = +pep.halfLife
    const ka = +(pep.absorptionRate || 0.8)
    const pepId   = pep.id?.startsWith('virtual_') ? injKey : (pep.id || injKey)
    const pepName = pep.name
    let allInjHrs = injectionTimesForPK(pepId, pepName, winStart, winEnd)
    if (blendName) {
      const parentPep = S.peptides.find(p => p.name === blendName)
      if (parentPep) {
        const parentHrs = injectionTimesForPK(parentPep.id, blendName, winStart, winEnd)
        allInjHrs = [...new Set([...allInjHrs, ...parentHrs])].sort((a,b)=>a-b)
      }
    }
    const STEPS = 300
    const points = []
    for (let i = 0; i <= STEPS; i++) {
      const tHrs = (i / STEPS) * totalHrs
      const level = cumulativeLevel(tHrs, allInjHrs, hl, ka)
      points.push({ tHrs, level })
      if (level > globalMax) globalMax = level
    }
    curves.push({ pep, blendName, points, injHrs: allInjHrs, color: peptideColor(pep.name) })
  }

  if (globalMax === 0) {
    return '<div style="text-align:center;padding:32px;color:var(--text4);font-size:13px">No injection records found for selected peptides in the last ' + S.hlWindowDays + ' days.<br>Import your injection CSV from the Calendar tab first.</div>'
  }

  const yMax = Math.max(globalMax * 1.1, 110)
  const threshold = +S.hlThreshold || 20
  const px2 = tHrs => padL + (tHrs / totalHrs) * cW
  const py2 = level => padT + cH - (level / yMax) * cH
  const nowX = px2((now - winStart) / 3600000)

  let grid = '', yLabels = '', xLabels = '', curvePaths = '', nowLine = '', threshLine = '', injMarkers = ''

  const yTicks = [0,25,50,75,100,...(yMax>110?[150,200]:[])].filter(v=>v<=yMax)
  for (const tick of yTicks) {
    const y = py2(tick)
    const is100 = tick===100
    grid += '<line x1="'+padL+'" y1="'+y.toFixed(1)+'" x2="'+( padL+cW)+'" y2="'+y.toFixed(1)+'" stroke="' + (is100?'#0072B2':'#e5e5e7')+'" stroke-width="' +(is100?1.5:1)+'" ' +(is100?'stroke-dasharray="4,3"':'') +'/>'
    yLabels += '<text x="'+( padL-4).toFixed(1)+'" y="' +(y+3).toFixed(1)+'" text-anchor="end" class="axis-label" ' +(is100?'fill="#0072B2" font-weight="700"':'') +'>'+tick+'%</text>'
  }

  const dayCount = Math.ceil(totalHrs/24)
  for (let d=0; d<=dayCount; d++) {
    const tHrs = d*24
    const x = px2(tHrs)
    if (x<padL||x>padL+cW) continue
    const date = new Date(winStart.getTime()+tHrs*3600000)
    grid += '<line x1="'+x.toFixed(1)+'" y1="'+padT+'" x2="'+x.toFixed(1)+'" y2="' +(padT+cH).toFixed(1)+'" stroke="#e5e5e7" stroke-width="1"/>'
    if (d%Math.max(1,Math.floor(dayCount/8))===0)
      xLabels += '<text x="'+x.toFixed(1)+'" y="' +(padT+cH+14).toFixed(1)+'" text-anchor="middle" class="axis-label">' + date.toLocaleDateString('en-US',{month:'short',day:'numeric'})+'</text>'
  }

  const ty = py2(threshold)
  threshLine = '<line x1="'+padL+'" y1="'+ty.toFixed(1)+'" x2="' +(padL+cW).toFixed(1)+'" y2="'+ty.toFixed(1)+'" stroke="var(--yellow)" stroke-width="1.5" stroke-dasharray="6,3"/><text x="' +(padL+cW+2).toFixed(1)+'" y="' +(ty+3).toFixed(1)+'" class="axis-label" fill="var(--yellowT)">'+threshold+'%</text>'

  if (nowX>=padL&&nowX<=padL+cW)
    nowLine = '<line x1="'+nowX.toFixed(1)+'" y1="'+padT+'" x2="'+nowX.toFixed(1)+'" y2="' +(padT+cH).toFixed(1)+'" stroke="#D55E00" stroke-width="2" stroke-dasharray="3,2"/><text x="'+nowX.toFixed(1)+'" y="' +(padT-4).toFixed(1)+'" text-anchor="middle" class="axis-label" fill="#D55E00" font-weight="700">NOW</text>'

  for (const { pep, points, injHrs, color } of curves) {
    const pts = points.map(p => px2(p.tHrs).toFixed(1)+','+py2(p.level).toFixed(1)).join(' ')
    curvePaths += '<polyline points="'+pts+'" fill="none" stroke="'+color+'" stroke-width="2.5" stroke-linejoin="round" opacity="0.9"/>'
    const nowHrs = (now-winStart)/3600000
    const nowLevel = cumulativeLevel(nowHrs, injHrs, +pep.halfLife, +(pep.absorptionRate||0.8))
    if (nowX>=padL&&nowX<=padL+cW) {
      const ny = py2(nowLevel)
      curvePaths += '<circle cx="'+nowX.toFixed(1)+'" cy="'+ny.toFixed(1)+'" r="5" fill="'+color+'" stroke="white" stroke-width="1.5"/><text x="' +(nowX+7).toFixed(1)+'" y="' +(ny-4).toFixed(1)+'" class="axis-label" fill="'+color+'" font-weight="700">'+nowLevel.toFixed(0)+'%</text>'
    }
    for (const ti of injHrs) {
      const x = px2(ti)
      if (x>=padL&&x<=padL+cW)
        injMarkers += '<line x1="'+x.toFixed(1)+'" y1="' +(padT+cH).toFixed(1)+'" x2="'+x.toFixed(1)+'" y2="' +(padT+cH+6).toFixed(1)+'" stroke="'+color+'" stroke-width="2"/>'
    }
  }

  return '<svg viewBox="0 0 '+W+' '+H+'" class="chart-svg" style="max-width:100%">'+grid+yLabels+xLabels+threshLine+curvePaths+injMarkers+nowLine+'</svg>'
}

function renderHLLegend(pepsToPLot, lastInj) {
  return pepsToPLot.map(function(entry) {
    var pep = entry.pep, blendName = entry.blendName, injKey = entry.injKey
    var inj = lastInj[injKey] || lastInj[pep.id]
    var nameSpan = esc(pep.name)
      + (blendName ? ' <span style="color:var(--text4)">(' + esc(blendName) + ')</span>' : '')
      + ' (t\u00bd=' + pep.halfLife + 'h)'
    var timeSpan = inj
      ? '<span style="color:var(--text4)">\u2014 last: ' + fmt(inj.date) + ' ' + fmt12(inj.time) + '</span>'
      : '<span style="color:var(--text4)">\u2014 no injection data</span>'
    return '<div class="chart-legend-item">'
      + '<div class="chart-legend-dot" style="background:' + peptideColor(pep.name) + '"></div>'
      + '<span>' + nameSpan + '</span>'
      + timeSpan
      + '</div>'
  }).join('')
}

function hlToggle(id) {
  const i = S.hlSelected.indexOf(id)
  if (i >= 0) S.hlSelected.splice(i, 1)
  else S.hlSelected.push(id)
  render()
}

export {
  svgBarChart,
  svgLineChart,
  renderCorrelationChart,
  renderAnalyticsTab,
  cumulativeLevel,
  injectionTimesForPK,
  batemanPct,
  renderHalfLifeTab,
  renderCalendarPKChart,
  renderHLLegend,
  hlToggle
}
